import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import classNames from "classnames";

import CardWrapper from "cards/components/CardWrapper";
import styles from "./IssuesModule.css";

import { moduleInViewDataLayerEvent } from "utils/analytics";

class IssuesModule extends Component {
  constructor(props) {
    super(props);
    this.trackInView = this._trackInView.bind(this);
    this.observer = this.createIntersectionObserver();
    this.ref = React.createRef();
  }

  _trackInView(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        moduleInViewDataLayerEvent(
          "deep_dive_issues_module",
          this.props.moduleSlug
        );
      }
    });
  }

  componentDidMount() {
    this.observer.observe(this.ref.current);
  }

  createIntersectionObserver() {
    return new IntersectionObserver(this.trackInView, { threshold: 0 });
  }

  componentWillUnmount() {
    this.observer.disconnect();
  }

  render() {
    return (
      <div ref={this.ref}>
        <CardWrapper contentId={this.props.moduleSlug}>
          <h4 className={styles.title}>Go deeper with these related topics:</h4>
          <div className={styles.boxes}>
            {this.props.boxes.map((box, index) => {
              return (
                <Link
                  key={box.tagSlug}
                  className={classNames(styles.box, "gtm-issues-module-link")}
                  //The HTMLElement.style method is used to access this element's backgroundColor in
                  // GTM through a custom js variable. It only works on inline-set styles, and was
                  // chosen because the alternate go-to css-accessing method
                  // (window.getComputedStyle(el)) is more susceptible to race conditions. Since it
                  //is for inline styles only, if this component's backgroundColor is changed to be
                  //set differently, that GTM variable will need to changed as well.
                  style={{ backgroundColor: box.backgroundColor }}
                  to={`/tag/${box.tagSlug}`}
                  data-content-id={index}
                >
                  {box.name}
                </Link>
              );
            })}
          </div>
        </CardWrapper>
      </div>
    );
  }
}

IssuesModule.propTypes = {
  moduleSlug: PropTypes.string,
  boxes: PropTypes.arrayOf(
    PropTypes.shape({
      tagSlug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      backgroundColor: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default IssuesModule;
